<template>
<!--新闻详情-->
  <div class="newsItem">
    <div class="imgBox" >
      <img :src="itemData.content.boxImg.urlData" class="imgBox_img">
    </div>
    <div class="newsItem1">
      <div class="itemContent" v-for="itemALl in itemData.content.itemData" v-show="itemALl.showData">
        <div class="newsItemCount" v-for="item in itemALl.content">
          <div class="newsItemCount_text" v-if="item.type.content == 'text'">
            {{item.item}}
          </div>
          <div class="newsItemCount_img" v-if="item.type.content == 'img'">
            <img :src = "item.item" class="newsItemCount_img_1">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Data } from './js/newsItem.js';

export default {
  name: "newsItem",
  data() {
    return {
      dataAll: Data,
      itemData: {},
      imageHeight: "596px",
      screenWidth: 0,
      menuIndex: "1",
      url:"http://116.62.38.250//image//nr/tp/gywm.jpg",
      urlData:""
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }

    that.initData();


  },
  methods:{
    initData(){
      let that = this;
      let path = that.urlData;
      if(path == '' || path == undefined){
        path =hat.itemData.content.itemData[0].path.content;
      }
      for(let index in that.itemData.content.itemData){
        let item = that.itemData.content.itemData[index];
        if(path == item.path.content){
          item.showData =true;
        } else {
          item.showData = false;
        }
      }
    }
  }
}
</script>

<style scoped>
/*.newsItemCount_img_1{*/
/*  width: 100%;*/
/*  */
/*}*/
.newsItemCount_img{
  display: flex;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1120/240;

}
.newsItemCount_text{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
  white-space: pre-wrap;
}
.itemContent{
  width: 78%;
}
.newsItem1{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 80px;
}

.imgBox_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.imgBox{
  width: 100%;
  padding-top: 41.39%;
  position: relative;
}
.news{
  background: #FFFFFF;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/newsItem.vue